import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';
const lazyModule = new LazyModule<typeof lazyIndex>(() => import('./lazyIndex'), {
    name: 'common/controls/packages/options/config/mail/owa-groups-inbox-rules-option',
});

export const lazyOpenRulesPanelInModal: LazyAction<
    typeof lazyIndex.openRulesPanelInModal,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.openRulesPanelInModal);
